var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.002,
  d: "M5.401 10.256c0 .789-.76 1.428-1.7 1.428-.938 0-1.699-.64-1.699-1.428 0-.79.761-1.429 1.7-1.429.938 0 1.7.64 1.7 1.429Zm0 0V4.12c0-.766.503-1.439 1.233-1.649l2.55-.735c1.086-.313 2.166.51 2.166 1.649V8.54m0 0c0 .79-.76 1.429-1.7 1.429-.938 0-1.699-.64-1.699-1.429s.761-1.428 1.7-1.428c.938 0 1.7.64 1.7 1.428Z",
  opacity: 0.4
})));
export default SvgMusic;